/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-03-08",
    versionChannel: "nightly",
    buildDate: "2024-03-08T00:18:02.691Z",
    commitHash: "1f4be86b18f27e19d88af2a450a951f0311b217a",
};
